import type { PreloaderSettingsType } from '@/services/preloaders/types'
import { REFLECT_METADATA } from '@/decorators/types'

export function PreloaderSettings(settings: PreloaderSettingsType) {
  return function <T extends { new (...args: any[]): any }>(constructor: T) {
    // save metadata on original constructor
    Reflect.defineMetadata(REFLECT_METADATA.PreloaderSettings, settings, constructor)

    // add settings method to prototype instead of creating new class
    constructor.prototype.settings = function () {
      return settings
    }

    // return original constructor without changes
    return constructor
  }
}
